import { CloudfrontMetaInformationResponse } from './types'
import apiFetchClient from '../client'

const cloudfrontMetaInformation = async (): Promise<CloudfrontMetaInformationResponse | null> => {
    try {
        const result = await apiFetchClient<CloudfrontMetaInformationResponse>(
            '/cloudfront-meta-information/',
            {
                method: 'GET',
            }
        )
        return result
    } catch (error) {
        console.error('Failed to load cloudfront meta information', error)
        return null
    }
}

export default cloudfrontMetaInformation
